// dev
// const API_BASE_URL = 'https://vh369.by2040.ihb.by';
// production
const API_BASE_URL = 'https://elated-turing.178-124-131-24.plesk.page';

const useEndpoints = () => {
  return {
    UPLOADS: `https://api.good-day.by/uploads`,

    CITIES: `${API_BASE_URL}/city/all`,
    LOGIN_ADMIN: `${API_BASE_URL}/posters/login-admin`,

    CREATE_ADMIN: `${API_BASE_URL}/posters/create-admin`,
    ADMINS: `${API_BASE_URL}/posters/admins`,
    ADMIN_UPDATE: `${API_BASE_URL}/posters/update-admin`,
    ADMIN_DELETE: `${API_BASE_URL}/posters/delete-admin`,

    POSTERS_ALL: `${API_BASE_URL}/posters/all`,
    POSTERS_ALL_WITH_CITY: `${API_BASE_URL}/posters/all-with-city`,
    POSTERS_BY_ID: `${API_BASE_URL}/posters/`,
    POSTERS_ADD: `${API_BASE_URL}/posters/add-poster`,
    POSTERS_DELETE: `${API_BASE_URL}/posters/delete-poster`,
    POSTERS_UPDATE: `${API_BASE_URL}/posters/update-poster`,

    INFO: `${API_BASE_URL}/posters/info`,
    INFO_ADD: `${API_BASE_URL}/posters/add-info`,
    INFO_UPDATE: `${API_BASE_URL}/posters/update-info`,
    INFO_DELETE: `${API_BASE_URL}/posters/delete-info`,

    CATEGORIES: `${API_BASE_URL}/posters/categories`,
    CATEGORIES_ADD: `${API_BASE_URL}/posters/add-category`,
    CATEGORIES_DELETE: `${API_BASE_URL}/posters/delete-category`,
    CATEGORIES_UPDATE: `${API_BASE_URL}/posters/update-category`,

  };
};

export default useEndpoints;
